<template>
  <div class="container">
    <div class="screen btnBox clearfix">
      <div class="button inquire" @click="editRoles">添加角色</div>
    </div>
    <div class="screen clearfix">
      <div class="item">
        <span>角色名称</span>
        <div class="box">
          <el-input v-model="screen.role_name" placeholder="输入角色名称" style="width: 240px"></el-input>
        </div>
      </div>
      <div class="item">
        <span>状态</span>
        <div class="box">
          <el-select v-model="screen.status" filterable :popper-append-to-body="false" placeholder="全部"
                     style="width: 180px">
            <el-option
                v-for="item in dictData.status"
                :key="item.id"
                :label="item.value"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <span class="button inquire" @click="search">查询</span>
      <span class="button" @click="resetQuery">重置</span>
    </div>
    <el-table
        ref="multipleTable"
        :data="tableData.data"
        :border="true"
        v-loading="tableData.loading"
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="60"
          align="center">
      </el-table-column>
      <el-table-column
          prop="role_name"
          label="角色名称"
          min-width="100%">
      </el-table-column>
      <el-table-column
          prop="rule"
          label="权限">
      </el-table-column>
      <el-table-column
          label="状态"
          width="100"
          align="center">
        <template slot-scope="scope">
          <el-switch
              :value="scope.row.status"
              :active-value="1"
              :inactive-value="2"
              :disabled="scope.row.id == 1 ||scope.row.id == 2"
              @change="forbiddenRole(scope.row.id, scope.row.status)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="添加时间">
      </el-table-column>
      <el-table-column
          label="操作"
          width="110">
        <template slot-scope="scope">
          <span class="handle" :style="{color: (scope.row.id !== 2)? '#3984F5' : '#CEDAE0'}" @click="(scope.row.id !== 2) ? editRoles(scope.row) : ''">编辑</span>
          <span class="handle" @click="(scope.row.id !== 1 && scope.row.id !== 2)? deleteData(scope.row.id) : ''"
                :style="{color: (scope.row.id !== 1 && scope.row.id !== 2)? '#3984F5' : '#CEDAE0'}">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="operate">
      <div class="handle">
        <div class="all-select">
          <el-checkbox :indeterminate="tableData.isIndeterminate" v-model="tableData.allSelect"
                       @change="toggleSelection()"></el-checkbox>
        </div>
        <div class="button" @click="deleteData()">批量删除</div>
      </div>
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="screen.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="screen.limit"
          layout="prev, pager, next, sizes"
          :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

const defaultQuery = {
  page: 1, // 请求页码
  limit: 10, // 每页显示条数
  role_name: '',
  status: null
}
export default {
  name: 'Roles',
  data() {
    return {
      dictData: {
        // 1=启用 2=禁用
        status: [
          {
            id: 1,
            value: '启用'
          },
          {
            id: 2,
            value: '禁用'
          }
        ]
      },
      screen: {
        ...defaultQuery
      }, // 筛选条件
      tableData: {
        data: [], // 表格列表数据
        isIndeterminate: false, // 表格是否有选中但未全选
        allSelect: false, // 表格全选
        multipleSelection: [], // 表格选中列表
        currentPage: 1, // 表格当前页码
        total: 0, // 总条数
        loading: false, // 表格渲染loading
        ids: [], // 表格选中列表id值
      }, // 表格数据
    }
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    handleSelectionChange(val) {
      this.tableData.multipleSelection = val;
      this.tableData.ids = val.map(item => item.id);
      this.tableData.isIndeterminate = val.length > 0 && val.length < this.tableData.data.length;
      this.tableData.allSelect = val.length === this.tableData.data.length ? true : false;
    }, // 表格选中改变
    toggleSelection() {
      this.$refs.multipleTable.toggleAllSelection();
    }, // 表格全选
    handleSizeChange(val) {
      this.screen.limit = val;
      this.getDataList();
    }, // 分页pageSize改变
    handleCurrentChange(val) {
      this.screen.page = val;
      this.getDataList();
    }, // 分页currentPage改变
    /**
     * 查询
     */
    search() {
      this.getDataList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.screen = {
        ...defaultQuery
      }
      this.search();
    },
    /**
     * 获取字典列表数据
     */
    getDataList() {
      this.tableData.loading = true;
      this.$api.roleList(this.screen).then(res => {
        console.log(res,145)
        this.$set(this.tableData, 'data', res.data.data);
        this.$set(this.tableData, 'total', res.data.count);
      }).finally(() => {
        this.tableData.loading = false;
      })
    },
    /**
     * 列表数据删除
     */
    deleteData(id) {
      if (!id && this.tableData.ids.length === 0) {
        this.$message({
          type: 'info',
          message: '请选择需要删除的数据！'
        });
        return false;
      }

      let mData = this.tableData.multipleSelection.filter(item => item.role_name === '商企经理' || item.role_name === '普通管理员');
      if (mData.length > 0) {
        this.$message({
          message: id ? '当前角色不可删除' : '选项中包含不可删除的角色',
          type: 'warning'
        });
        return false;
      }

      let ids = id ? id : this.tableData.ids;

      this.$confirm('是否确认删除当前角色？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.delRole(ids).then((res) => {
          this.$message({
            type: 'success',
            message: res.msg
          });
          this.resetQuery()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 禁用/启用角色
    forbiddenRole(id, status) {
      const newStatus = status === 1 ? 2 : 1;
      status = newStatus
      if (!id && this.tableData.ids.length === 0) {
        this.$message({
          type: 'info',
          message: '请选择需要禁用的数据！'
        });
        return false;
      }
      let ids = id ? id : this.tableData.ids;
      if (ids == 1 || ids == 2){
        this.$message({
          message: '当前角色无法禁用！',
          type: 'warning'
        });
        return false;
      }else {
        this.$api.editRoleStatus({id: ids, status}).then(() => {
          this.$message({
            type: 'success',
            message: status === 2 ? '禁用成功!' : '启用成功！'
          });
          this.getDataList();
        })
      }
    },
    editRoles(row) {
      let id = row?.id
      console.log(id)
      let path = id || id === 0 ? '/editRoles' : '/addRoles';
      console.log(path, 111111)
      this.$router.push({path, query: {id: id}})
    },
  }
}
</script>

<style lang="scss" scoped src="@/styles/common.scss"></style>
<style lang="scss" scoped>
.container {
  margin: 18px;
  padding: 30px 20px;
  width: calc(100% - 76px);
  height: calc(100% - 96px);
  background: #FFFFFF;
  overflow: scroll;
  scrollbar-width: none;
}
</style>
